common.View.create('galaxy::habitats.website.layouts.Main', {

    onDOMLoad()
    {
        this.initFooter();
        this.initSecondMenu();
        this.initSearch();
    },

    initFooter()
    {
        // Resize window
        $(window).resize(() => {
            this.initHeaderFooterSpacing();
        });

        // Set footer spacing
        this.initHeaderFooterSpacing();
    },

    initHeaderFooterSpacing()
    {
        // Is visible?
        if( this.element.find('footer .mobile-footer').is(':visible') ) {
            this.element.find('.wrapper')
                .css('padding-top', this.element.find('header .mobile-nav').outerHeight())
                .css('padding-bottom', this.element.find('footer .mobile-footer').outerHeight())
                .find('[class*="main-Secondmenu"], .sticky-top')
                    .css('top', this.element.find('header .mobile-nav').outerHeight())
                    .end()
            ;
        } else {
            this.element.find('.wrapper')
                .css('padding-top', this.element.find('header .desktop-nav').outerHeight())
                .css('padding-bottom', 0)
                .find('[class*="main-Secondmenu"], .sticky-top')
                    .css('top', this.element.find('header .desktop-nav').outerHeight())
                    .end();
        }
    },

    initSecondMenu()
    {
        this.element.find('.mmenuToggler')
            .on('click', (event) => {
                // Set as active
                $(event.currentTarget).toggleClass('is-active');

                // Fade menu
                this.element.find('[class*="main-Secondmenu"]').fadeToggle('fast');
            });
    },

    initSearch()
    {
        this.element
            .find('.searchIcon')
                .on('click', (event) => {
                    
                    let instance = this.element.find('.galaxy\\:\\:habitats-website-partials-search-Index').data('instance');

                    instance.show();

                    return false;
                    
                })
                .end()
            .find('.search form')
                .on('submit', (event) => {
                    // Show search
                    this.element.find('.galaxy\\:\\:habitats-website-partials-search-Index')
                        .removeClass('tw-hidden')
                        .find('input[name="query"]')
                            .val( this.element.find('.search form input').val() )
                            .trigger('change')
                            .end();

                    // Stop default behavior
                    return false;
                });
    }

});
